const styles = ({ typography }) => ({
  content: {
    backgroundColor: "#fafafa",
    width: "100%",
    height: "100%",
  },
});

export default styles;
